import React, { PropsWithChildren, useRef } from 'react'
import Overlay from './Overlay'
import { Flex } from 'theme-ui'
import useOnClickOutside from 'utils/useOnClickOutside'

export default function Popup({
  children,
  dismiss,
}: PropsWithChildren<{ dismiss: () => void }>): React.ReactElement {
  const popupRef = useRef<HTMLDivElement>(null)

  useOnClickOutside([popupRef], () => dismiss())

  return (
    <Overlay>
      <Flex
        data-testid="video-popup"
        ref={popupRef}
        sx={{
          width: ['100%', '67.2rem'],
          px: '1.6rem',
          zIndex: 'zIndex601',
        }}
      >
        {children}
      </Flex>
    </Overlay>
  )
}
